import type {ReactElement} from 'react';
import React from 'react';
import type {RecentColorPalettesProps} from './recent-color-palettes.types';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {ColorPalettesLoadingSkeleton} from '@Components/color-palettes/color-palettes-loading-skeleton/color-palettes-loading-skeleton';
import {ColorPalettesContainer} from '@Components/color-palettes/color-palettes-container';
import {setColorPaletteBeingApplied} from '@/reducers/color-palettes.reducer';

const MAXIMUM_VISIBLE_PALETTES_RECENT = 3;

export function RecentColorPalettes({...props}: RecentColorPalettesProps): ReactElement | null {
  const dispatch = useAppDispatch();

  const recentPalettes = useAppSelector((state) => {
    return state.colorPalettes.recentPalettes;
  });

  const onColorPaletteDoneApplying = (): void => {
    dispatch(setColorPaletteBeingApplied(undefined));
  };

  const getRecentsColorPaletteComponent = (): ReactElement | null => {
    if (!recentPalettes) {
      return <ColorPalettesLoadingSkeleton />;
    }

    if (props.showSearchResults) {
      return null;
    }

    if (recentPalettes.length === 0) {
      return null;
    }

    return (
      <ColorPalettesContainer
        onColorPaletteDoneApplying={onColorPaletteDoneApplying}
        colorPaletteAppliedEvent={props.colorPaletteAppliedEvent}
        allowShuffle={props.allowShuffle}
        showApplyingState={props.showApplyingState}
        heading={window.i18next.t('pmwjs_recents')}
        colorPalettes={recentPalettes}
        onColorPaletteSelected={props.handlePaletteSelect}
        maximumVisiblePalettes={MAXIMUM_VISIBLE_PALETTES_RECENT}
        showPaletteName={false}
        showNameOverlayOnHover
      />
    );
  };

  return getRecentsColorPaletteComponent();
}
